import React from 'react';
import type {
  DietaryProperty,
  IngredientModification,
} from '@sg/graphql-schema';
import { CustomizationIngredientsGrid } from '@sg/shared-fe/features/customization';

import { type IngredientModificationWithQuantity } from '../../../../types';
import { ProductDetailsIngredientCard } from '../ProductDetailsIngredientCard';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsIngredientCardWrapper = (
  props: ProductDetailsIngredientCardWrapperProps,
) => {
  const {
    ingredientModifications,
    activeIngredientsModificationsMap,
    palette,
    activeStepperId,
    isAtMaxQuantity,
    setActiveStepperId,
    onIncrement,
    onDecrement,
    getRestrictionNotice,
    resetStepperTimeout,
  } = props;

  return (
    <CustomizationIngredientsGrid.SectionStack>
      {ingredientModifications.map((modification) => {
        const { ingredient } = modification;
        const maybeActiveIngredient = activeIngredientsModificationsMap.get(
          ingredient.id,
        );
        const activeIngredientQuantity = maybeActiveIngredient?.quantity ?? 0;
        const dietaryRestrictionNote = getRestrictionNotice(
          ingredient?.dietaryProperties,
        );

        return (
          <ProductDetailsIngredientCard
            key={ingredient.id}
            ingredientModification={modification}
            quantity={activeIngredientQuantity}
            palette={palette}
            activeStepperId={activeStepperId}
            isAtMaxQuantity={isAtMaxQuantity}
            dietaryRestrictionNote={dietaryRestrictionNote}
            onIncrement={onIncrement}
            onDecrement={onDecrement}
            setActiveStepperId={setActiveStepperId}
            resetStepperTimeout={resetStepperTimeout}
          />
        );
      })}
    </CustomizationIngredientsGrid.SectionStack>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type ProductDetailsIngredientCardWrapperProps = {
  ingredientModifications: readonly IngredientModification[];
  activeIngredientsModificationsMap: Map<
    string,
    IngredientModificationWithQuantity
  >;
  palette?: 'kale' | 'spinach';
  activeStepperId: string | null;
  isAtMaxQuantity: boolean;
  setActiveStepperId: (stepperId: string | null) => void;
  resetStepperTimeout: () => void;
  onIncrement: (ingredientModification: IngredientModification) => void;
  onDecrement: (ingredientModification: IngredientModification) => void;
  getRestrictionNotice: (
    dietaryProperties: readonly DietaryProperty[] | undefined,
  ) => string;
};
